import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import {
  AppBar,
  CssBaseline,
  Drawer,
  Hidden,
  IconButton,
  Toolbar,
  Typography
} from '@material-ui/core';
import 'primereact/resources/themes/saga-green/theme.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import NotificationsIcon from '@material-ui/icons/Notifications';
import ChatIcon from '@material-ui/icons/Chat';
import AppMenu from "../views/AppMenu";
import AppAccordionMenu from "../components/AppAccordionMenu";
import {AppDetails, dateStyle, languageJson, timeZone} from 'config';
import { useSelector } from 'react-redux';
import { Sidebar } from 'primereact/sidebar';
import { Badge } from 'primereact/badge';
import audio from 'assets/audio/alert-canceled-booking.mp3';
import chatAudio from 'assets/audio/alert-chat.mp3';
import pendingAudio from 'assets/audio/alert-pending-booking.mp3';
import { Message } from 'primereact/message';

const drawerWidth = 290;
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  menuButtonLg: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  canceledNotify: {
    color: '#ffffff'
  }
}));

function ResponsiveDrawer(props) {
  const languageCode = useSelector(state => state.languagedata.languageCode);
  const language = languageJson[languageCode];
  const { container } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [drawerLgOpen, setDrawerLgOpen] = React.useState(false);
  const [drawerNotificationsOpen, setDrawerNotificationsOpen] = React.useState(false);
  const [drawerChatNotificationsOpen, setDrawerChatNotificationsOpen] = React.useState(false);
  const [notificationsData, setNotificationsData] = React.useState(null);
  const [chatNotificationsData, setChatNotificationsData] = React.useState(null);
  const [executeAnimation, setExecuteAnimation] = React.useState(false);
  const [executeChatAnimation, setExecuteChatAnimation] = React.useState(false);
  const [countNotifications, setCountNotifications] = React.useState(0);
  const history = useHistory();
  const auth = useSelector(state => state.auth);
  const dashboardnotificationsdata = useSelector(state => state.dashboardnotificationsdata.data);
  const chatnotificationsdata = useSelector(state => state.chatnotificationsdata.data);

  useEffect(() => {
    console.log('notifications: ', dashboardnotificationsdata);
    if (dashboardnotificationsdata !== null) {
      setNotificationsData(dashboardnotificationsdata);
    } else {
      setNotificationsData([])
    }

    if (notificationsData !== null && dashboardnotificationsdata !== null) {
      let notification_sound = audio;
      if (dashboardnotificationsdata[0].type === 'booking_pending') {
        notification_sound = pendingAudio;
      }

      playAlertSound(notification_sound);
      setExecuteAnimation(true);
      setTimeout(() => {
        setExecuteAnimation(false);
      }, 6000);
    }
  }, [dashboardnotificationsdata]);

  useEffect(() => {
    console.log('notifications: ', chatnotificationsdata);
    if (chatnotificationsdata !== null) {
      const newArr = chatnotificationsdata.filter(row => {
        if (typeof row.reviewed === typeof undefined) {
          return true;
        } else {
          return !row.reviewed.includes(auth.info?.uid);
        }
      });

      setChatNotificationsData(newArr);
    } else {
      setChatNotificationsData([])
    }

    if (notificationsData !== null && chatnotificationsdata !== null) {
      if (chatnotificationsdata.length > countNotifications) {
        if (chatnotificationsdata[0]?.from.uid !== auth.info?.uid) {
          let notification_sound = chatAudio;

          playAlertSound(notification_sound);
          setExecuteChatAnimation(true);
          setTimeout(() => {
            setExecuteChatAnimation(false);
          }, 6000);
        }
      }

      setCountNotifications(chatnotificationsdata.length);
    }
  }, [chatnotificationsdata]);

  const playAlertSound = (notification_sound) => {
    new Audio(notification_sound).play();
  };

  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  }

  const handleDrawerToggleLg = () => {
    setDrawerLgOpen(!drawerLgOpen);
  }

  const goToNotificationDetail = (notification) => {
    setDrawerNotificationsOpen(false);
    history.push({
      pathname: "/bookingsadvance",
      state: {
        booking_id: notification.id
      }
    })
  }

  const goToChatNotificationDetail = (notification) => {
    setDrawerChatNotificationsOpen(false);
    history.push({
      pathname: "/chat"
    })
  }

  console.log('Render Responsive drawer');

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" style={{
        marginLeft: drawerLgOpen ? drawerWidth : 0,
        width: drawerLgOpen ? `calc(100% - ${drawerWidth}px)` : '100%'
      }}>
        <Toolbar style={{ backgroundColor: '#00763F', justifyContent: 'space-between' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggleLg}
            className={classes.menuButtonLg}
          >
            {drawerLgOpen ?
              <CloseIcon />
              :
              <MenuIcon />
            }
          </IconButton>
          <Typography variant="h6" noWrap style={{ color: '#00763F' }}>
            {AppDetails.web_name}
          </Typography>
          <div>

            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={() => {
                //history.push('/canceledbookings');
                setDrawerChatNotificationsOpen(true);
              }}
              className={classes.canceledNotify}
            >
              <ChatIcon />
              {chatNotificationsData !== null && chatNotificationsData.length > 0 ?
                <span className={executeChatAnimation ? 'zoomin animation-duration-1000 animation-iteration-infinite' : ''} style={{
                  position: 'absolute',
                  top: 7,
                  right: 5,
                  backgroundColor: '#FE2C25',
                  borderRadius: 10,
                  fontSize: 10,
                  fontWeight: '700',
                  paddingTop: 2,
                  paddingRight: 4,
                  paddingBottom: 2,
                  paddingLeft: 4
                }}>{chatNotificationsData.length}</span>
                : null}
            </IconButton>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={() => {
                //history.push('/canceledbookings');
                setDrawerNotificationsOpen(true);
              }}
              className={classes.canceledNotify}
            >
              <NotificationsIcon />
              {notificationsData !== null && notificationsData.length > 0 ?
                <span className={executeAnimation ? 'zoomin animation-duration-1000 animation-iteration-infinite' : ''} style={{
                  position: 'absolute',
                  top: 7,
                  right: 10,
                  backgroundColor: '#FE2C25',
                  borderRadius: 10,
                  fontSize: 10,
                  fontWeight: '700',
                  paddingTop: 2,
                  paddingRight: 4,
                  paddingBottom: 2,
                  paddingLeft: 4
                }}>{notificationsData.length}</span>
                : null}
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <Sidebar blockScroll visible={drawerNotificationsOpen} position="right" onHide={() => setDrawerNotificationsOpen(false)}>
        <h4 className='font-bold'>{language.notifications} <Badge value={notificationsData !== null ? notificationsData.length : 0} severity="danger"></Badge></h4>
        <div className='mt-4'>
          {notificationsData !== null && notificationsData.length > 0 ? notificationsData.map((notification, key) => {
            return (
              <div
                key={key}
                className="flex flex-nowrap justify-content-between align-items-center border-1 surface-border border-round p-2 mb-2 cursor-pointer select-none hover:surface-hover transition-colors transition-duration-150"
                tabIndex="0"
                onClick={() => {
                  if (notification.type === 'booking') {
                    goToNotificationDetail(notification);
                  }
                }}
              >
                <div className="flex align-items-center">
                  <div className="flex-column hidden md:flex">
                    {notification.type === 'booking_pending' ?
                      <span className="font-semibold block text-sm">
                        {language.new_pending_guest_booking}
                      </span>
                      :
                      <span className="font-semibold block text-sm">
                        {language.trip_canceled}
                      </span>
                    }
                    <span className="block text-overflow-ellipsis overflow-hidden white-space-nowrap w-15rem text-xs mb-2">
                      {new Date(notification.created_at).toLocaleString(dateStyle, { timeZone: timeZone })}
                    </span>
                    <span className="block text-overflow-ellipsis overflow-hidden white-space-nowrap w-15rem text-sm">
                      <i className='pi pi-map-marker text-teal-700' style={{ fontSize: '0.8rem' }}></i> {notification.data.pickup}
                    </span>
                    <span className="block text-overflow-ellipsis overflow-hidden white-space-nowrap w-15rem text-sm">
                      <i className='pi pi-flag text-red-700' style={{ fontSize: '0.8rem' }}></i> {notification.data.drop}
                    </span>
                  </div>
                </div>
              </div>
            )
          })
            :
            <Message severity="info" text={language.no_notifications} />
          }
        </div>
      </Sidebar>
      <Sidebar blockScroll visible={drawerChatNotificationsOpen} position="right" onHide={() => setDrawerChatNotificationsOpen(false)}>
        <h4 className='font-bold'>{language.chat_notifications} <Badge value={chatNotificationsData !== null ? chatNotificationsData.length : 0} severity="danger"></Badge></h4>
        <div className='mt-4'>
          {chatNotificationsData !== null && chatNotificationsData.length > 0 ? chatNotificationsData.map((notification, key) => {
            return (
              <div
                key={key}
                className="flex flex-nowrap justify-content-between align-items-center border-1 surface-border border-round p-2 mb-2 cursor-pointer select-none hover:surface-hover transition-colors transition-duration-150"
                tabIndex="0"
                onClick={() => {
                  goToChatNotificationDetail(notification);
                }}
              >
                <div className="flex align-items-center">
                  <div className="flex-column hidden md:flex">
                    <span className="font-bold text-teal-700 block text-sm">
                      <i className='pi pi-envelope text-teal-700' style={{ fontSize: '0.8rem' }}></i> {notification.to === 'all' ? language.public_chat : language.admin_chat}
                    </span>
                    <span className="block text-overflow-ellipsis overflow-hidden white-space-nowrap w-15rem text-xs mb-2">
                      {new Date(notification.created_at).toLocaleString(dateStyle, { timeZone: timeZone })}
                    </span>
                    <span className="block font-semibold text-overflow-ellipsis overflow-hidden white-space-nowrap w-15rem text-sm">
                      {notification.from.name + ' ' + language.said}
                    </span>
                    <span className="block text-overflow-ellipsis overflow-hidden white-space-nowrap w-15rem text-sm">
                      {notification.text}
                    </span>
                  </div>
                </div>
              </div>
            )
          })
            :
            <Message severity="info" text={language.no_notifications} />
          }
        </div>
      </Sidebar>
      <nav aria-label="mailbox folders"
        style={{
          width: drawerLgOpen ? drawerWidth : 0
        }}
      >

        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {auth?.info?.profile?.usertype === 'admin' || auth?.info?.profile?.usertype === 'fleetadmin' ?
              <AppAccordionMenu />
              :
              <AppMenu />
            }
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="persistent"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={drawerLgOpen}
            onClose={handleDrawerToggleLg}
          >
            {auth?.info?.profile?.usertype === 'admin' || auth?.info?.profile?.usertype === 'fleetadmin' ?
              <AppAccordionMenu />
              :
              <AppMenu />
            }
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="persistent"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={drawerLgOpen}
            onClose={handleDrawerToggleLg}
          >
            {auth?.info?.profile?.usertype === 'admin' || auth?.info?.profile?.usertype === 'fleetadmin' ?
              <AppAccordionMenu />
              :
              <AppMenu />
            }
          </Drawer>
        </Hidden>
      </nav>
      <main style={{
        marginLeft: drawerLgOpen ? 20 : 0,
        flexGrow: 1,
        padding: 25,
        width: drawerLgOpen ? `calc(100% - ${drawerWidth}px)` : '100%'
      }}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  );
}

ResponsiveDrawer.propTypes = {
  container: PropTypes.instanceOf(typeof Element === 'undefined' ? Object : Element),
};

export default ResponsiveDrawer;
